module.exports = __webpack_public_path__ + "static/media/plumen-filter.c68308c4.jpeg";